/**
 * voyager 打点
 */

import Voyager from './index';

let voyagerInstance = null;
/**
 * 追踪事件 public方法
 * @param {String} eventName 事件名称
 * @param {Object} params 事件的自定义参数, json {"key1": "value1","key2": "value2"}
 */
export default function track(trackName, trackParams) {
  if (!voyagerInstance) {
    voyagerInstance = new Voyager({});
  }

  return voyagerInstance.trackEvent(trackName, '', trackParams);
}
/**
 *  持续事件开始
 *  @param {String} eventName 持续事件的名称
 *  @param {String} eventKey 持续事件的key, 用来区分用一个name的不同事件. 可能是feed_id之类的
 *  @param {Object} params 事件的自定义参数, json {"key1": "value1","key2": "value2"}
 *  @param {Boolean} endWithRawSession 如果为true，则在rawSession结束时，自动结束该Event
 */
export function trackBegin(
  trackName,
  trackKey,
  trackParams,
  endWithRawSession
) {
  if (!voyagerInstance) {
    voyagerInstance = new Voyager({});
  }

  return voyagerInstance.beginTrackEvent(
    trackName,
    trackKey,
    trackParams,
    endWithRawSession
  );
}
/**
 *  持续事件结束
 *  @param {String} eventName 持续事件的名称
 *  @param {String} eventKey 持续事件的key, 用来区分用一个name的不同事件. 可能是feed_id之类的
 *  @param {Object} params 事件的自定义参数, json {"key1": "value1","key2": "value2"}
 */
export function trackEnd(trackName, trackKey, trackParams) {
  if (!voyagerInstance) {
    voyagerInstance = new Voyager({});
  }

  return voyagerInstance.endTrackEvent(trackName, trackKey, trackParams);
}
